import React, { Component } from 'react';
import MarkdownScript from 'helpers/markdownScript';
import TermsAndConditions from './auth/termsAndConditions.md';

const md = new MarkdownScript(TermsAndConditions);

export default class DataUsage extends Component {

  render () {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: md.getAllAsHtml()}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/termsAndConditions.jsx